import { render, staticRenderFns } from "./social-login.vue?vue&type=template&id=49c12930&scoped=true"
import script from "./social-login.vue?vue&type=script&lang=js"
export * from "./social-login.vue?vue&type=script&lang=js"
import style0 from "./social-login.vue?vue&type=style&index=0&id=49c12930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c12930",
  null
  
)

export default component.exports